import { axios } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import { PaginatedResults } from "@sdk/utils/paginated-results";
import type { iBooking } from "@sdk/bookings/booking-model";
import type { iBookingDiscussionItem } from "@sdk/bookings/booking-discussion-item-model";

export class BookingDiscussionItemsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.bookingDiscussionItems.configure(config);
  }

  constructor(protected config: { basePath: string; token: string }) {
    this.bookingDiscussionItems = {
      configure: (cfg: { basePath?: string; token?: string }) => {
        Object.assign(this.config, cfg);
      },
      getByBookingId: async (
        bookingId: string,
        params: { page?: number; limit?: number } = {}
      ): Promise<PaginatedResults<iBookingDiscussionItem>> => {
        const page = Math.max(1, Number(params.page) || 1);
        const limit = Math.min(Math.max(1, Number(params.limit) || 20), 100);
        const search = new URLSearchParams({
          page: String(page),
          limit: String(limit),
        });
        const results = await axios.get(
          this.config.basePath +
            `/bookings/${bookingId}/discussion-items?${search}`,
          { headers: { Authorization: this.config.token } }
        );
        return results.data;
      },
      addMessage: async (
        bookingId: string,
        body: Pick<
          iBookingDiscussionItem,
          "content" | "attachments" | "taskId"
        > & {
          raiseFlag?: "red" | "blue";
          requireValidation?: boolean;
          requireComment?: boolean;
        }
      ): Promise<{ item: iBookingDiscussionItem; booking: iBooking }> => {
        const results = await axios.post(
          this.config.basePath + `/bookings/${bookingId}/discussion-items`,
          body,
          { headers: { Authorization: this.config.token } }
        );
        return results.data;
      },
    };
    this.bookingDiscussionItems.configure(config);
  }

  bookingDiscussionItems!: {
    configure: (config: { basePath?: string; token?: string }) => void;
    getByBookingId: (
      bookingId: string,
      params?: { page?: number; limit?: number }
    ) => Promise<PaginatedResults<iBookingDiscussionItem>>;
    addMessage: (
      bookingId: string,
      body: Pick<
        iBookingDiscussionItem,
        "content" | "attachments" | "taskId"
      > & {
        raiseFlag?: "red" | "blue";
        requireValidation?: boolean;
        requireComment?: boolean;
      }
    ) => Promise<{ item: iBookingDiscussionItem; booking: iBooking }>;
  };
}

export const bookingDiscussionItemsServices =
  new BookingDiscussionItemsServices(SDKConfig);
